import React, { useState, useEffect } from "react";
import { Link, NavLink, useHistory } from "react-router-dom";
import { Dropdown, Modal, Button } from "react-bootstrap";
import UserModal from "../../../components/User/Stat/Modal";
import storage from "utils/Storage";
import { __, addNewStyle, API, CRISTP_ID, decode, defaultAvatar, encode, getUID, toUSD, wait, Event } from 'utils/Helper';
import PrivateMessage from "./../PrivateMessage";
import Logout from "./../../Auth/Logout";
import styled from "styled-components";
import {
  Heart,
  Menu,
  PencilIcon,
  User2,
  User2Icon,
  UserRound,
  Wallet2,
  X,
  Settings2,
  Camera,
} from "lucide-react";
import UserCreditModal from "./WalletModal";
import socket from "utils/Socket";
import C from 'utils/Constant';
import { getVipLevelDetails } from "../../../pages/Offers/VipClub/calculateLevel";

import { Edit } from "lucide-react";
import Cookies from "js-cookie";
import { useTransactionsQuery } from "hooks/useWallet";
import { getAllSupportedTimezones, getUserTimezone, formatUserDateTime } from "utils/timezoneHelper";

const UploadAvatarLabel = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 2px dashed #1fc16b;
  background-color: rgba(31, 193, 107, 0.05);
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  margin: 0;

  &:hover {
    background-color: rgba(31, 193, 107, 0.15);
    border-color: #fff;
    transform: scale(1.08);
    
    svg {
      color: #fff !important;
    }
    span {
      color: #fff !important;
    }
  }
`;

const AvatarOption = styled.img`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.1);
  object-fit: cover;
  cursor: pointer;
  transition: all 0.25s ease-in-out;

  &:hover {
    transform: scale(1.08);
    border-color: #1fc16b;
    box-shadow: 0 0 10px rgba(31, 193, 107, 0.4);
  }
`;

const Container = styled.div`
  background-color: rgb(58 65 66);
  display: flex;
  border-radius: 0.5rem;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: 768px) {
    background-color: transparent !important;
    border: none !important;
  }
`;

const CubBalance = styled.div`
  color: #99999;
  font-size: 14px;
  font-weight: bold;
  margin-right: 10px;

  @media (max-width: 425px) {
    margin-right: 0px;
  }

  @media (max-width: 865px) {
    margin-right: 0px;
  }
`;

const ModalTop = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
const StyledModal = styled(Modal)`
  .modal-content {
    background-color: #292d2e;
    border-radius: 12px;
    border: none;
  }
  .modal-dialog {
    width: 90%;
    margin: 1.75rem auto;
    @media (min-width: 576px) {
      max-width: 380px;
    }
  }
`;
const ModalBody = styled(Modal.Body)`
  padding: 0 20px 15px;
  background-color: #292d2e;
`;

const ModalHeader = styled(Modal.Header)`
  border-bottom: none;
  padding: 15px 20px 5px;
  margin-top: 8px !important;
`;

const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const InputContainer = styled.div`
  margin-bottom: 12px;
`;

const StyledButtonNew = styled.button`
  background-image: linear-gradient(90deg, #24ee89, #9fe871);
  box-shadow: 0 0 12px #23ee884d, 0 -2px #1dca6a inset;
  color: black;
  font-weight: bold;
  padding: 0.5rem 1.25rem;
  border-radius: 0.375rem;
  width: 100%;
  max-width: 20rem;
  transition: all 0.3s ease-in-out;
  border: none;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 4px;
  font-size: 11px;
  color: #a0a0a0;
  font-family: normal;
`;

const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px 14px;
  background-color: #25282c;
  border: 1px solid #3a3a3a;
  border-radius: 8px;
  color: #ffffff;
  font-size: 12px;
`;

const Select = styled.select`
  width: 100%;
  padding: 10px 14px;
  background-color: #25282c;
  border: 1px solid #3a3a3a;
  border-radius: 8px;
  color: #ffffff;
  font-size: 12px;
  outline: none;
  cursor: pointer;

  option {
    background-color: #25282c;
    color: #ffffff;
  }
`;

const StyledButton = styled(Button)`
  background-color: ${(props) => (props.primary ? "#6C5CE7" : "#4A4D56")};
  border: none;
  border-radius: 10px;
  color: #fff;
  font-weight: bold;
  padding: 12px;
  margin-bottom: 10px;
  transition: all 0.3s ease;

  &:hover,
  &:focus {
    background-color: ${(props) => (props.primary ? "#5849C2" : "#3A3D46")};
  }
`;

const HertContainer = styled.div`
  background-color: #1c1d21;
  padding: 0px 0.75rem;
  border-radius: 15px;

  @media (max-width: 230px) {
    display: none;
  }
`;
const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
const FlexContainerStar = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
`;

const Pencil = styled.div`
display:flex;
justify-content:center
background-color:#1C1D21;
padding: 0.75rem;
border-radius:50%;

@media(max-width:230px){
display:none;
}
`;

const StatisticsTotal = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  align-item: center;
  margin-top: 10px;

  /* For large screens, items are displayed in a row */
  @media (min-width: 568px) {
    flex-direction: row;
  }

  /* For small screens, items are stacked in a column */
  // @media (max-width: 567px) {
  //   flex-direction: column;

  // }
`;

const UserContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 5px;
  // padding:5px;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  background-color: #1e1e1e;
  padding: 20px;
  border-radius: 8px;
  max-width: 300px;
`;

const GridItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  color: #ffffff;
  font-size: 14px;
`;

const IconWrapper = styled.div`
  margin-right: 10px;
`;

const MenuContainer = styled.div`
  display: block;
  align-items: center;
  gap: 14px;
  height: 100%;
  max-height: 75vh;
  margin-top: 10px;
  // border:1px solid red;
  overflow-y: scroll !important;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const MenuItem = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: clamp(10px, 3vw, 14px);
  width: 100%;
  margin-right: 12px;
  align-items: center;
`;

const MenuItemContent = styled.div`
  color: #b9c4c7;
  cursor: pointer;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 14px;
  padding: 6px 12px;
  border-radius: 10px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #3a4142;
  }
`;

const IconWrapperNew = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
`;

const StyledImg = styled.img`
  height: 18px;
  width: 18px;
  filter: invert(48%) sepia(6%) saturate(426%) hue-rotate(167deg)
    brightness(94%) contrast(87%);
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;

  &:hover {
    opacity: 0.8;
  }
`;

const ProgressBarContainer = styled.div`
  background-color: #1e2024;
  border-radius: 20px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const ProgressBarText = styled.span`
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
`;

const ProgressBarWrapper = styled.div`
  background-color: #424a55;
  border-radius: 20px;
  height: 8px;
  width: 85%;
`;

const ProgressBarFill = styled.div`
  background-color: #ffffff;
  border-radius: 10px;
  height: 100%;
  width: ${(props) => props.progress}%;
`;

// Styled components
const Container1 = styled.div`
  color: white;
  padding: 16px;
  border-radius: 12px;
  width: 100%;
`;

const HeaderButtonGroup = styled.div`
  display: flex;
  background-color: transparent;
  border-radius: 50px;
  margin-bottom: 16px;
  width: 50%;
`;

const HeaderButton = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 16px;
  border-radius: 10px;
  transition: all 0.3s ease;
  text-align: center;
  font-weight: bold;
  ${(props) =>
    props.active
      ? `
        background-color: #65EB7C;
        color: black;
      `
      : `
        background-color: transparent;
        color:white;
        &:hover {
          background-color:rgba(101, 235, 123, 0.26);
          color: black;
        }
      `}
`;

const TableHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  color: #9ca3af;
  font-size: 14px;
  margin-bottom: 16px;
`;

const TableRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  font-size: 14px;
  color: white;
  margin-bottom: 12px;
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 0;
`;

const PlaceholderImage = styled.img`
  margin-bottom: 16px;
  width: 100px;
  height: 100px;
`;

const PlaceholderText = styled.p`
  color: #9ca3af;
`;

// Main ModalBody content
const ModalContent = () => {
  const [activeTab, setActiveTab] = useState("Deposit");
  const uid = getUID || parseFloat(Cookies.get("uid")); // Get UID from your function

  const { data: transactionData = [], isLoading: loading, error: queryError } = useTransactionsQuery(activeTab, uid);
  const error = queryError ? "Failed to fetch data." : null;

  const formatDateTime = (dateString) => {
    return formatUserDateTime(dateString);
  };

  return (
    <Container1>
      {/* Header Buttons */}
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <HeaderButtonGroup>
          <HeaderButton
            active={activeTab === "Deposit"}
            onClick={() => setActiveTab("Deposit")}
          >
            Deposit
          </HeaderButton>
          <HeaderButton
            active={activeTab === "Withdraw"}
            onClick={() => setActiveTab("Withdraw")}
          >
            Withdraw
          </HeaderButton>
        </HeaderButtonGroup>
      </div>

      {/* Content */}
      {loading ? (
        <EmptyState>
          <PlaceholderText>Loading data...</PlaceholderText>
        </EmptyState>
      ) : error ? (
        <EmptyState>
          <PlaceholderText>{error}</PlaceholderText>
        </EmptyState>
      ) : transactionData.length === 0 ? (
        <EmptyState>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "300px",
              width: "100%",
            }}
          >
            <img
              src="/assets/images/emptyPanda.webp"
              style={{ height: "400px", width: "200px", objectFit: "contain" }}
            />
            <PlaceholderText>No transactions available.</PlaceholderText>
          </div>
        </EmptyState>
      ) : (
        <>
          <div style={{ height: "300px" }}>
            {/* Table Header */}
            <TableHeader style={{ color: "#9ca3af" }}>
              <div>Date</div>
              <div>Amount</div>
              <div>Status</div>
              <div>
                {activeTab === "Deposit" ? "Transaction" : "Address"}
              </div>{" "}
              {/* For deposit it's orderid, for withdraw it's wallet */}
            </TableHeader>

            {/* Table Rows */}
            {transactionData.map((transaction, index) => (
              <TableRow style={{ color: "#9ca3af" }} key={index}>
                <div>
                  {activeTab === "Deposit"
                    ? formatDateTime(transaction.created_at)
                    : formatDateTime(transaction.date)}
                </div>{" "}
                {/* Time */}
                <div>{transaction.amount}</div> {/* Amount */}
                <div>{transaction.status}</div> {/* State */}
                <div>
                  {activeTab === "Deposit"
                    ? transaction.orderid
                    : transaction.wallet}
                </div>{" "}
                {/* Transaction */}
              </TableRow>
            ))}
          </div>
        </>
      )}
    </Container1>
  );
};
class User extends React.Component {
  constructor(props) {
    super(props);
    const currentName =
      storage.getKey("name") !== undefined ? storage.getKey("name") : "Guest";
    this.state = {
      level: 1,
      displayUid: getUID || parseFloat(Cookies.get("uid")),
      name: currentName,
      avatar: defaultAvatar,
      showPopup: false,
      showPopupUserProfile: false,
      showPopupUserProfileStatistics: false,
      showWalletModal: false,
      showCurrencyModal: false,
      activeSection: "deposit",
      haveData: "",
      data: [],
      currentLevel: "vip 0",
      isModalOpen: false,
      nextLevel: "vip 1",
      progress: 0,
      xpNeeded: 1,
      currentXP: 0,
      vipDetails: null,
      wageredAmount: null,
      isUpdatingUsername: false,
      newUsername: currentName, // Initialize with current username
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      address: "",
      timezone: storage.getKey("timezone") || "",
      updateError: null,
      loaded: false,
      isModalOpen2: false,
      selectedImage: "https://api.dicebear.com/7.x/bottts/svg?seed=1",
    };
    this.progressAnimationRef = React.createRef();
  }


  openModal = () => {
    this.setState({ isModalOpen2: true });
  };

  closeModal = () => {
    this.setState({ isModalOpen2: false });
  };

  handleImageSelect = (image) => {
    this.setState({ selectedImage: image, isModalOpen2: false });
  };

  handleCustomImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('avatar', file);

    try {
      const response = await fetch(`${API}/upload-avatar`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${storage.getKey('token')}`
        },
        body: formData
      });

      const data = await response.json();
      if (data.success) {
        this.setState({ selectedImage: data.url, isModalOpen2: false });
      } else {
        alert("Failed to upload image");
      }
    } catch (error) {
      console.error("Image upload error:", error);
      alert("An error occurred during upload");
    }
  };


  handleUsernameChange = (event) => {
    this.setState({ newUsername: event.target.value });
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  updateUsername = async () => {
    const { newUsername, displayUid, selectedImage } = this.state;

    if (!newUsername || !newUsername.trim()) {
      this.setState({ updateError: "Username cannot be empty" });
      return;
    }

    this.setState({ isUpdatingUsername: true, updateError: null });

    try {
      const response = await fetch(
        `${API}/editProfile`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uid: displayUid,
            username: newUsername.trim(),
            selectedImage: selectedImage,
            first_name: this.state.firstName,
            last_name: this.state.lastName,
            email: this.state.email,
            phone: this.state.phone,
            address: this.state.address,
            timezone: this.state.timezone
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update username");
      }

      const data = await response.json();

      console.log("datat is", data);

      // Update local storage and state with new username & timezone
      storage.setKey("name", newUsername);
      storage.setKey("avatar", selectedImage);
      if (this.state.timezone) {
        storage.setKey("timezone", this.state.timezone);
      }
      this.setState((prevState) => ({
        name: newUsername,
        showEditUi: false,
        data: {
          ...(prevState.data || {}),
          avatar: selectedImage,
          timezone: this.state.timezone,
        },
      }));

      // Optionally, refresh user info
      socket.emit(
        C.USER_INFO,
        encode({
          id: getUID || parseFloat(Cookies.get("uid")),
          coin: storage.getKey("coin") ? storage.getKey("coin") : "",
          rate: null,
          game: "all",
          first: true,
        })
      );
    } catch (error) {
      this.setState({
        updateError: "Failed to update username. Please try again.",
      });
    } finally {
      this.setState({ isUpdatingUsername: false });
    }
  };

  getUserInfo = (data) => {
    if (data.status) {
      console.log("data received", data);
      let avatar = data.avatar || this.state.selectedImage || "https://api.dicebear.com/7.x/bottts/svg?seed=1";
      if (avatar.endsWith('avatar.png') || avatar.endsWith('avtar_img.png')) {
        avatar = "https://api.dicebear.com/7.x/bottts/svg?seed=1";
      }

      this.setState((prevState) => ({
        haveData: "ok",
        data: data,
        firstName: data.first_name || data.firstName || prevState.firstName || "",
        lastName: data.last_name || data.lastName || prevState.lastName || "",
        email: data.email || prevState.email || "",
        phone: data.phone || prevState.phone || "",
        address: data.address || prevState.address || "",
        timezone: data.timezone || prevState.timezone || "",
        newUsername: data.name || prevState.newUsername,
        selectedImage: avatar
      }));

      if (data.timezone) {
        storage.setKey('timezone', data.timezone);
      }

      let wageredAmount = parseFloat(data?.profit).toFixed(4);
      if (wageredAmount) {
        this.setState({ wageredAmount });
        const vipDetails = getVipLevelDetails(wageredAmount);
        this.setState({ vipDetails });
        this.animateProgress(parseFloat(vipDetails.completionPercentage));
      }
    } else {
      this.setState({ notFound: true });
    }
  };

  componentDidMount() {
    socket.on(C.USER_INFO, (data) => this.getUserInfo(decode(data)));
    socket.emit(
      C.USER_INFO,
      encode({
        id: getUID || parseFloat(Cookies.get("uid")),
        coin: storage.getKey("coin") ? storage.getKey("coin") : "",
        rate: null,
        game: "all",
        first: true,
      })
    );

    // Immediately load avatar from DB via REST to avoid showing default on fresh browser
    const uid = getUID || parseFloat(Cookies.get("uid"));
    if (uid) {
      const token = storage.getKey('token');
      fetch(`${API}/api/myprofile/${uid}`, {
        headers: token ? { 'Authorization': `Bearer ${token}` } : {}
      })
        .then(res => res.ok ? res.json() : null)
        .then(profileData => {
          if (!profileData) return;
          const profile = (profileData.data && profileData.data[0]) || profileData.user || profileData;
          if (!profile) return;
          // Extract avatar: from profile JSON column or top-level
          let avatar =
            (profile.profile && profile.profile.avatar) ||
            profile.avatar ||
            null;
          if (avatar && !avatar.endsWith('avatar.png') && !avatar.endsWith('avtar_img.png')) {
            this.setState({ selectedImage: avatar });
          } else {
            this.setState({ selectedImage: "https://api.dicebear.com/7.x/bottts/svg?seed=1" });
          }
          // Also pre-fill email/phone/timezone in case socket hasn't responded yet
          if (profile.timezone) {
            storage.setKey('timezone', profile.timezone);
          }
          this.setState((prev) => ({
            email: profile.email || prev.email || '',
            phone: profile.phone || prev.phone || '',
            timezone: profile.timezone || prev.timezone || '',
            newUsername: (profile.profile && profile.profile.name) || profile.name || prev.newUsername,
          }));
        })
        .catch(err => console.error('Failed to load profile on mount:', err));
    }

    Event.on("force_modal_my_profile", this.handleTogglePopup);
  }

  componentWillUnmount() {
    if (this.progressAnimationRef.current) {
      cancelAnimationFrame(this.progressAnimationRef.current);
    }
    Event.removeListener("force_modal_my_profile", this.handleTogglePopup);
  }

  animateProgress = (targetProgress) => {
    let currentProgress = 0;
    const duration = 1000; // 1 second animation
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      currentProgress = progress * targetProgress;
      this.setState({ progress: currentProgress });

      if (progress < 1) {
        this.progressAnimationRef.current = requestAnimationFrame(animate);
      }
    };

    this.progressAnimationRef.current = requestAnimationFrame(animate);
  };

  handleTogglePopup = async () => {
    console.log("get ui", getUID);
    const uid = getUID || parseFloat(Cookies.get("uid"));

    // Emit socket request for full user info (balance, stats, etc.)
    socket.emit(
      C.USER_INFO,
      encode({
        id: uid,
        coin: storage.getKey("coin") ? storage.getKey("coin") : "",
        rate: null,
        game: "all",
        first: true,
      })
    );

    // Also fetch fresh profile via REST API to guarantee email/phone are loaded
    // (fixes race condition where socket response arrives before listener is ready)
    try {
      const token = storage.getKey('token');
      const response = await fetch(`${API}/api/myprofile/${uid}`, {
        headers: token ? { 'Authorization': `Bearer ${token}` } : {}
      });
      if (response.ok) {
        const profileData = await response.json();
        // Response shape: { status: true, data: [user] }
        const profile = (profileData.data && profileData.data[0]) || profileData.user || profileData;
        if (profile) {
          this.setState((prev) => ({
            email: profile.email || prev.email || '',
            phone: profile.phone || prev.phone || '',
            firstName: profile.first_name || (profile.profile && profile.profile.first_name) || prev.firstName || '',
            lastName: profile.last_name || (profile.profile && profile.profile.last_name) || prev.lastName || '',
            address: profile.address || (profile.profile && profile.profile.address) || prev.address || '',
            newUsername: (profile.profile && profile.profile.name) || profile.name || prev.newUsername,
            // Also restore avatar from DB so it persists across browsers, or fallback if it's default
            selectedImage:
              (profile.profile && profile.profile.avatar && !profile.profile.avatar.endsWith('avatar.png') && !profile.profile.avatar.endsWith('avtar_img.png'))
                ? profile.profile.avatar
                : (profile.avatar && !profile.avatar.endsWith('avatar.png') && !profile.avatar.endsWith('avtar_img.png'))
                ? profile.avatar
                : "https://api.dicebear.com/7.x/bottts/svg?seed=1",
          }));
        }
      }
    } catch (err) {
      console.error('Failed to fetch profile via REST:', err);
    }

    this.setState((prevState) => ({
      showPopup: !prevState.showPopup,
    }));
  };

  handleTogglePopupProfile = () => {
    console.log("profile");
    this.setState((prevState) => ({
      showPopupUserProfile: !prevState.showPopupUserProfile,
    }));
  };

  handleTogglePopupProfileStatistics = () => {
    this.setState((prevState) => ({
      showPopupUserProfileStatistics: !prevState.showPopupUserProfileStatistics,
    }));
  };
  toggleModal = () => {
    this.setState((prevState) => ({ isModalOpen: !prevState.isModalOpen }));
  };


  render() {

    const preSetImages = [
      "https://api.dicebear.com/7.x/bottts/svg?seed=1",
      "https://api.dicebear.com/7.x/bottts/svg?seed=2",
      "https://api.dicebear.com/7.x/bottts/svg?seed=3",
      "https://api.dicebear.com/7.x/bottts/svg?seed=4",
      "https://api.dicebear.com/7.x/bottts/svg?seed=5",
      "https://api.dicebear.com/7.x/bottts/svg?seed=6",
      "https://api.dicebear.com/7.x/bottts/svg?seed=7",
      "https://api.dicebear.com/7.x/bottts/svg?seed=8",
    ];


    const {
      displayUid,
      level,
      name,
      avatar,
      showPopup,
      showPopupUserProfile,
      showPopupUserProfileStatistics,
      vipDetails,
      progress,
      showEditUi,
      isUpdatingUsername,
      updateError,
      newUsername,
      isModalOpen,
    } = this.state;
    const { t } = this.props;

    console.log("show edit", showEditUi);

    let uid = displayUid;
    if (__.isNaN(uid)) {
      uid = name;
    }

    return (
      <li className={"user-dropdown"}>
        <Dropdown right="true">
          <Container>
            <Dropdown className="d-none d-sm-block">
              <Dropdown.Toggle
                variant="link"
                id="dropdown-split-user"
                onClick={this.handleTogglePopup}
              >
                <img
                  className="profile-dropdown-img"
                  src={this.state.selectedImage || "https://api.dicebear.com/7.x/bottts/svg?seed=1"}
                  alt="profile-user"
                  style={{
                    height: "38px",
                    width: "38px",
                    borderRadius: "50%",
                    objectFit: "contain",
                  }}
                />
              </Dropdown.Toggle>
            </Dropdown>

            <StyledModal
              show={showPopup}
              onHide={this.handleTogglePopup}
              centered
            >
              <ModalHeader>
                <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                  User Profile
                </div>

                <X
                  style={{ cursor: "pointer" }}
                  onClick={this.handleTogglePopup}
                  size={24}
                />
              </ModalHeader>
              <ModalBody>
                <div style={{ width: "100%", height: "auto" }}>
                  <div>
                    <div>
                      <div
                        className="avatar-container"
                        style={{
                          width: "100%",
                          justifyContent: "center",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <img
                          className="image-change-avatar"
                          style={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "50%",
                          }}
                          src={this.state.selectedImage}
                          alt="Avatar"
                          onClick={this.openModal}
                        />
                        <div className="edit-icon" onClick={this.openModal}>
                          ✎
                        </div>
                      </div>

                      {this.state.isModalOpen2 && (
                        <div className="custom-modal-overlay">
                          <div className="custom-modal-content">
                            <div className="custom-modal-header">
                              <h3 style={{ color: "white" }}>Select an Avatar</h3>
                              <X style={{ cursor: "pointer", color: "white" }}
                                onClick={this.closeModal}
                                size={24}
                              />
                            </div>
                            <div className="custom-modal-body" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px 10px' }}>
                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', justifyContent: 'center', alignItems: 'center' }}>
                                <input 
                                  type="file" 
                                  accept="image/*" 
                                  id="avatarUpload" 
                                  style={{ display: 'none' }} 
                                  onChange={this.handleCustomImageUpload}
                                />
                                <UploadAvatarLabel htmlFor="avatarUpload">
                                  <Camera size={20} style={{ color: '#1fc16b', marginBottom: '2px', transition: 'all 0.2s' }} />
                                  <span style={{ fontSize: '9px', color: '#1fc16b', fontWeight: '800', textTransform: 'uppercase', transition: 'all 0.2s' }}>Upload</span>
                                </UploadAvatarLabel>

                                {preSetImages.map((image, index) => (
                                  <AvatarOption
                                    key={index}
                                    src={image}
                                    alt={`Avatar ${index + 1}`}
                                    onClick={() => this.handleImageSelect(image)}
                                  />
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <InputContainer>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <Label>Username</Label>
                      <span style={{ fontSize: "10px", color: "#888" }}>(Cannot be changed)</span>
                    </div>
                    <Input
                      type="text"
                      className="input-placeholder"
                      value={newUsername || ""}
                      placeholder="Username"
                      disabled={true}
                      style={{ cursor: "not-allowed", opacity: 0.8 }}
                    />
                  </InputContainer>

                  <InputContainer>
                    <Label>Email</Label>
                    <Input
                      type="email"
                      name="email"
                      className="input-placeholder"
                      value={this.state.email || ""}
                      placeholder="Enter email"
                      disabled={true}
                      style={{ cursor: "not-allowed", opacity: 0.8 }}
                    />
                  </InputContainer>

                  <InputContainer>
                    <Label>Mobile Number</Label>
                    <Input
                      type="text"
                      name="phone"
                      className="input-placeholder"
                      value={this.state.phone || ""}
                      placeholder="Enter mobile number"
                      disabled={true}
                      style={{ cursor: "not-allowed", opacity: 0.8 }}
                    />
                  </InputContainer>

                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "6px 2px",
                    marginBottom: "14px",
                    fontSize: "11px",
                    color: "#9ca3af"
                  }}>
                    <span>Edit Email or Mobile Number?</span>
                    <Link
                      to="/settings/account"
                      onClick={this.handleTogglePopup}
                      style={{ color: "#1fc16b", fontWeight: "600", textDecoration: "none" }}
                    >
                      Account Settings →
                    </Link>
                  </div>

                  {updateError && (
                    <Label style={{ color: "red", marginBottom: "8px" }}>{updateError}</Label>
                  )}

                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <StyledButtonNew
                      type="button"
                      onClick={this.updateUsername}
                      disabled={isUpdatingUsername}
                      style={{ width: "100%" }}
                    >
                      {isUpdatingUsername ? "Updating..." : "Modify"}
                    </StyledButtonNew>
                  </div>
                </div>
              </ModalBody>
            </StyledModal>

            <StyledModal
              show={showPopupUserProfileStatistics}
              onHide={this.handleTogglePopupProfileStatistics}
              centered
            >
              <ModalHeader>
                <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                  Details
                </div>

                <X
                  style={{ cursor: "pointer" }}
                  onClick={this.handleTogglePopupProfileStatistics}
                  size={24}
                />
              </ModalHeader>
              <ModalBody>
                <div>
                  <div
                    style={{
                      backgroundColor: "#323738",
                      padding: "18px 10px",
                      width: "100%",
                      borderRadius: "15px",
                      marginTop: "12px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <img src="\assets\bcimages\bcheader\statistics-icon.svg" />
                      <div style={{ color: "#FFFFFF" }}>Statistics</div>
                    </div>
                    <StatisticsTotal>
                      <div
                        style={{
                          width: "100%",
                          maxWidth: "250px",
                          borderRadius: "10px",
                          backgroundColor: "#3A4041",
                          padding: "10px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <div style={{ color: "#FFFFFF", fontSize: "12px" }}>
                            Total Wins
                          </div>
                          <div
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            {this.state.data?.wined}
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          maxWidth: "250px",
                          borderRadius: "10px",
                          backgroundColor: "#3A4041",
                          padding: "10px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <div style={{ color: "#FFFFFF", fontSize: "12px" }}>
                            Total Bets
                          </div>
                          <div
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            {this.state.data?.played}
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          maxWidth: "250px",
                          borderRadius: "10px",
                          backgroundColor: "#3A4041",
                          padding: "10px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <div style={{ color: "#FFFFFF", fontSize: "12px" }}>
                            Total Signup bonus
                          </div>
                          <div
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            {this.state.data?.profit}
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          maxWidth: "250px",
                          borderRadius: "10px",
                          backgroundColor: "#3A4041",
                          padding: "10px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <div style={{ color: "#FFFFFF", fontSize: "12px" }}>
                            Total Referral bonus
                          </div>
                          <div
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            {this.state.data?.profit}
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          maxWidth: "250px",
                          borderRadius: "10px",
                          backgroundColor: "#3A4041",
                          padding: "10px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <div style={{ color: "#FFFFFF", fontSize: "12px" }}>
                            Total Deposit bonus
                          </div>
                          <div
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            {this.state.data?.profit}
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          maxWidth: "250px",
                          borderRadius: "10px",
                          backgroundColor: "#3A4041",
                          padding: "10px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <div style={{ color: "#FFFFFF", fontSize: "12px" }}>
                            Total Bet bonus
                          </div>
                          <div
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              textAlign: "center",
                            }}
                          >
                            {this.state.data?.profit}
                          </div>
                        </div>
                      </div>
                    </StatisticsTotal>
                  </div>
                </div>
                {/* <StyledButton primary className="w-100">Edit Profile</StyledButton>
              <StyledButton className="w-100">View Settings</StyledButton> */}
              </ModalBody>
            </StyledModal>

            <StyledModal show={isModalOpen} onHide={this.toggleModal} centered>
              <ModalHeader>
                <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                  Transaction
                </div>

                <X
                  style={{ cursor: "pointer" }}
                  onClick={this.toggleModal}
                  size={24}
                />
              </ModalHeader>
              <ModalBody>
                <ModalContent />
              </ModalBody>
            </StyledModal>
            <CubBalance>
              <Dropdown>
                <Dropdown.Toggle variant="link" id="dropdown-split-menu">
                  <User2 size={22} className="user-icon-mobile" />
                  <Menu size={22} className="menu-icon-desktop" />
                </Dropdown.Toggle>
                <Dropdown.Menu
                  style={{ padding: "14px", marginLeft: "-319px" }}
                  className={"droper user-dropdown-detail"}
                >
                  {/* Dropdown header: click avatar/name → opens USER PROFILE popup */}
                  <div
                    onClick={this.handleTogglePopup}
                    style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '4px 0 10px 0', borderBottom: '1px solid rgba(255,255,255,0.08)', marginBottom: '6px', cursor: 'pointer' }}
                  >
                    <img
                      src={this.state.selectedImage || "https://api.dicebear.com/7.x/bottts/svg?seed=1"}
                      alt="avatar"
                      style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'contain', border: '2px solid rgba(255,255,255,0.12)' }}
                    />
                    <div style={{ color: '#fff', fontWeight: '600', fontSize: '14px' }}>{name}</div>
                  </div>
                  {/* <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div>{vipDetails?.previousVipLevel || 'VIP 0'}</div>
                                        <div>{vipDetails?.vipLevel || 'VIP 1'}</div>
                                    </div>
                                    <ProgressBarContainer style={{ marginTop: '2px' }}>
                                        <ProgressBarWrapper>
                                            <ProgressBarFill progress={progress} />
                                        </ProgressBarWrapper>
                                        <ProgressBarText>{progress.toFixed(1)}%</ProgressBarText>
                                    </ProgressBarContainer> */}

                  <div className="user-links">
                    <MenuContainer>
                      <Column>
                        <MenuItem>
                          <MenuItemContent onClick={this.handleTogglePopup}>
                            <IconWrapperNew>
                              <UserRound size={18} />
                            </IconWrapperNew>
                            <div>User Information</div>
                          </MenuItemContent>
                        </MenuItem>
                        {/* <MenuItem>
                          <MenuItemContent
                            onClick={() =>
                              this.setState({
                                showPopupUserProfileStatistics: true,
                              })
                            }
                          >
                            <IconWrapperNew>
                              <StyledImg
                                src="/assets/images/nanoicons/stats.png"
                                alt="Statistics"
                              />
                            </IconWrapperNew>
                            <div>Statistics</div>
                          </MenuItemContent>
                        </MenuItem> */}
                        <MenuItem
                          onClick={() => this.setState({ isModalOpen: false })}
                        >
                          <StyledLink style={{ width: "100%" }} to="/transactions/deposits">
                            <MenuItemContent>
                              <IconWrapperNew>
                                <StyledImg
                                  src="/assets/images/nanoicons/transactions.png"
                                  alt="Transactions"
                                />
                              </IconWrapperNew>
                              <div>Transactions</div>
                            </MenuItemContent>
                          </StyledLink>
                        </MenuItem>

                        <MenuItem
                          onClick={() => this.setState({ isModalOpen: false })}
                        >
                          <StyledLink style={{ width: "100%" }} to="/my-bets/api-games/settled">
                            <MenuItemContent>
                              <IconWrapperNew>
                                <StyledImg
                                  src="/assets/images/nanoicons/transactions.png"
                                  alt="My Bets"
                                />
                              </IconWrapperNew>
                              <div>My Bets</div>
                            </MenuItemContent>
                          </StyledLink>
                        </MenuItem>


                        <MenuItem>
                          <StyledLink style={{ width: "100%" }} to="/affiliate">
                            <MenuItemContent>
                              <IconWrapperNew>
                                <StyledImg
                                  src="/assets/images/nanoicons/affiliates.png"
                                  alt="Affiliate"
                                />
                              </IconWrapperNew>
                              <div>Affiliate</div>
                            </MenuItemContent>
                          </StyledLink>
                        </MenuItem>
                      </Column>

                      <Column>
                        {/* <MenuItemContent
                          onClick={() =>
                            this.setState({
                              activeSection: "deposit",
                              showWalletModal: true,
                            })
                          }
                        >
                          <IconWrapperNew>
                            <Wallet2 size={18} />
                          </IconWrapperNew>
                          <div>Wallet</div>
                        </MenuItemContent> */}
                        {/* <MenuItemContent
                          onClick={() => {
                            this.setState({
                              activeSection: "swap",
                              showWalletModal: true,
                            });
                          }}
                        >
                          <IconWrapperNew>
                            <StyledImg
                              src="/assets/images/nanoicons/nanoswap.png"
                              alt="Swap"
                            />
                          </IconWrapperNew>
                          <div>Swap</div>
                        </MenuItemContent>
                        <MenuItemContent
                          onClick={() => {
                            this.setState({
                              activeSection: "vaultpro",
                              showWalletModal: true,
                            });
                          }}
                        >
                          <IconWrapperNew>
                            <StyledImg
                              src="/assets/images/nanoicons/vault.png"
                              alt="Vault Pro"
                            />
                          </IconWrapperNew>
                          <div>Vault Pro</div>
                        </MenuItemContent> */}
                        <StyledLink to="/rewards">
                          <MenuItemContent>
                            <IconWrapperNew>
                              <StyledImg
                                src="/assets/images/nanoicons/rewards.png"
                                alt="Rewards"
                              />
                            </IconWrapperNew>
                            <div>Rewards</div>
                          </MenuItemContent>
                        </StyledLink>
                        {/* <MenuItemContent>
                          <Link
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                            to="/global-settings"
                          >
                            <img
                              style={{ height: "20px", width: "20px" }}
                              src="/assets/images/normal-seetings.png"
                              alt="Help Center Icon"
                            />
                            <div style={{ color: "#B9C4C7" }}>
                              Global Settings
                            </div>
                          </Link>
                        </MenuItemContent> */}
                        <StyledLink to="/vip-club">
                          <MenuItemContent>
                            <IconWrapperNew>
                              <StyledImg
                                src="/assets/images/nanoicons/vipclub.png"
                                alt="VIP club"
                              />
                            </IconWrapperNew>
                            <div>VIP club</div>
                          </MenuItemContent>
                        </StyledLink>
                        <StyledLink to="/settings/account">
                          <MenuItemContent>
                            <IconWrapperNew>
                              <Settings2 size={18} color="#B9C4C7" />
                            </IconWrapperNew>
                            <div>Settings</div>
                          </MenuItemContent>
                        </StyledLink>
                        <MenuItemContent>
                          <Logout />
                        </MenuItemContent>
                      </Column>
                    </MenuContainer>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </CubBalance>
          </Container>
        </Dropdown>

        {/* <UserCreditModal

                    showWalletModal={this.state.showWalletModal}
                    showCurrencyModal={this.state.showCurrencyModal}
                    activeSection={this.state.activeSection}
                    onToggleWalletModal={() => this.setState(prevState => ({ showWalletModal: !prevState.showWalletModal }))}
                    onToggleCurrencyModal={() => this.setState(prevState => ({ showCurrencyModal: !prevState.showCurrencyModal }))}
                    onSetActiveSection={(sectionId) => this.setState({ activeSection: sectionId })}


                /> */}
      </li>
    );
  }
}

class UserInfo extends React.Component {
  makeStars = (num) => {
    let stars = 5;
    let userLevel = stars - parseFloat(num);
    var g = [],
      o = [],
      f = [];
    for (var i = 0; i < userLevel; i++) {
      g.push(<span className="graysi">🏆</span>);
    }
    for (var i = 0; i < num; i++) {
      o.push(<span>🏆</span>);
    }
    f.push(o, g);
    return f;
  };
  render() {
    const { name, id, level, avatar, t } = this.props;

    return (
      <>
        <div>
          <UserContainer>
            <div style={{ display: "flex", gap: "5px" }}>
              {
                <UserModal
                  t={t}
                  username={name}
                  id={id}
                  menu={true}
                  avatar={avatar}
                />
              }
              <div>
                <div className="text-white">{name}</div>

                <div>{this.makeStars(level)}</div>
              </div>
            </div>
          </UserContainer>

          {/* <br /> */}
        </div>
      </>
    );
  }
}

export default User;
